import React from "react";
import Breadcrumbs from '../../components/Breadcrumbs/Breadcrumbs';
import TenderProcessTracker from "../../components/TenderProcessTracker/TenderProcessTracker";
import { useParams } from "react-router-dom";
import { ProductComparison }  from "../../components/TenderProcess"
import {
    ProductComparisonPageContainer,
} from "./ProductComparisonPage.styles";

export default function ProductComparisonPage() {
    const { tenderId, subStep } = useParams();
    return (
        <ProductComparisonPageContainer data-testid="main-content">
            <Breadcrumbs />
            <TenderProcessTracker />
            <ProductComparison tenderId={tenderId} subStep={subStep}/>
        </ProductComparisonPageContainer>
    );
}